import { getNumber, getJson, numConvert } from "../../../method";

export function compute(data) {

    const listName = ['end_varies_nts', 'end_varies_adr', 'end_varies_rev', 'end_varies_occ', 'ytd_varies_nts', 'ytd_varies_adr', 'ytd_varies_rev', 'ytd_varies_occ'];
    listName.forEach(name => {
        const BUDGET = name.split('_')[0] + '_budget_' + name.split('_')[2];
        const ACTUAL = name.split('_')[0] + '_actual_' + name.split('_')[2];
        data.forEach((item, i) => {
            data[i][name] = numConvert(item[BUDGET]) == 0 ? 0 : ((numConvert(item[ACTUAL]) - numConvert(item[BUDGET])) / numConvert(item[BUDGET])).toFixed(4);
        });
    });
    return data
}




// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Month/compute.js